import axios from "axios";
import { variables } from "../environments";

let config = {
  headers: {
    "Content-Type": "application/json",
    source: "pharmacyWeb",
    appVersionCode: variables.appVersionCode,
  },
};

const MED_DISTRIBUTION_URL = variables.MedDistributionUrl;

const getToken = async () => {
  let token;
  let authData = localStorage.getItem("userAuth");
  let onBehalfRetCode = localStorage.getItem("onBehalfRetCode");
  let userData = localStorage.getItem("userData");
  userData = JSON.parse(userData);

  if (authData && JSON.parse(authData).data.jwtToken) {
    token = JSON.parse(authData).data.jwtToken;
  }
  config.headers.Authorization = "Bearer " + token;

  if (
    onBehalfRetCode &&
    onBehalfRetCode.length > 0 &&
    onBehalfRetCode !== "undefined" &&
    (userData.admin || userData.salesPerson)
  ) {
    config.headers.adminRetailerCode = onBehalfRetCode;
    config.headers.source = "pharmacyWebOnbehalf";
  }
  return true;
};

export const getKavachSummary = async (retailerCode) => {
  await getToken();
  return axios.get(
    `${MED_DISTRIBUTION_URL}/distribution/retailer/${retailerCode}/summary`,
    { headers: config.headers },
  );
};

export const getKavachInsights = async (retailerCode) => {
  await getToken();
  return axios.get(
    `${MED_DISTRIBUTION_URL}/distribution/retailer/${retailerCode}/insights`,
    { headers: config.headers },
  );
};

export const getKavachServiceSummary = async (retailerCode) => {
  await getToken();
  return axios.get(
    `${MED_DISTRIBUTION_URL}/distribution/retailer/${retailerCode}/service-summary`,
    { headers: config.headers },
  );
};

export const getKavachTransactions = async (
  retailerCode,
  page = 0,
  size = 20,
) => {
  await getToken();
  return axios.get(
    `${MED_DISTRIBUTION_URL}/distribution/retailer/${retailerCode}/transactions`,
    { headers: config.headers, params: { page, size } },
  );
};

export const getUserInfoByRetailerCode = async (retailerCode) => {
  await getToken();
  return axios.get(`${MED_DISTRIBUTION_URL}/admin/getUserInfoByRetailerCode`, {
    headers: config.headers,
    params: { retailerCode },
  });
};

export const claimKavachReward = async (
  retailerCode,
  levelNumber,
  optionId,
) => {
  await getToken();
  return axios.post(
    `${MED_DISTRIBUTION_URL}/distribution/retailer/${retailerCode}/claim`,
    { levelNumber, optionId },
    { headers: config.headers },
  );
};

export const onboardRetailer = async (retailerCode) => {
  await getToken();
  return axios.post(
    `${MED_DISTRIBUTION_URL}/distribution/retailer/${retailerCode}/onboard`,
    null,
    { headers: config.headers },
  );
};
